//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DatasetLogDetail',
  props: {
    items: {
      type: Object,
      default: null
    }
  },
  watch: {
    items: function items(val) {
      console.log(val);
    }
  }
};